import { useContext } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Trans } from '@lingui/react';
import { Flex } from '@components/layout/Grid';
import LanguageContext from '@lib/contexts/languageContext';
import { UserContext } from '@lib/contexts/UserProvider';
import useLoginModal from '@lib/hooks/useLoginModal';
import { Button } from '@components/ButtonV2';

const ActionButton = styled(Button)`
  i {
    margin-right: 10px;
  }
`;

export const LiveGuestAuthSection = () => {
  const router = useRouter();
  const lang = useContext(LanguageContext);
  const [_, { refetch: refetchUser }] = useContext(UserContext);
  const [loginModal, { openModal: openLoginModal }] = useLoginModal({
    title: <Trans id="login_modal.title_for_payment" />,
    description: <Trans id="login_modal.helper_for_payment" />,
    callBack: (closeModal) => {
      refetchUser();
      closeModal();
    },
  });

  const registerUrl = {
    pathname: `/${lang}/register/account`,
    query: {
      to: router.asPath,
      code: '',
    },
  };

  const continueToRegister = (e) => {
    e.preventDefault();
    // go to register page
    router.push(registerUrl);
  };

  return (
    <>
      <Flex className="sticky bottom-0 flex flex-col xs:flex-row gap-3 w-full py-3 pt-5 bg-white">
        <ActionButton
          className="text-center justify-center"
          href={registerUrl}
          onClick={continueToRegister}
        >
          <Trans id="live.payment_page.action_button.register" />
        </ActionButton>
        <ActionButton
          className="text-center justify-center"
          href={`/${lang}/login`}
          onClick={(e) => {
            e.preventDefault();
            openLoginModal();
          }}
          outline
        >
          <Trans id="live.payment_page.action_button.login" />
        </ActionButton>
      </Flex>
      {loginModal}
    </>
  );
};
